import {
  BEGIN_EDITING_TEAM,
  SAVE_TEAM,
  SAVE_TEAM_SUCCESS,
  SAVE_TEAM_ERROR,
  END_EDITING_TEAM,
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  editing: false,
  team: null,
  syncingWithServer: false,
  teamIsNew: false,
  error: null,
  message: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case BEGIN_EDITING_TEAM:
      return {
        editing: true,
        team: action.payload,
        teamIsNew: (action.payload && action.payload._id) ? false : true,
        error: null,
        message: null,
      }
    case SAVE_TEAM:
      return {
        ...state,
        team: action.payload,//to update user locally
        syncingWithServer: true,
        error: null,
        message: null,
      }
    case SAVE_TEAM_SUCCESS:
      return {
        ...state,
        team: action.payload.team,
        syncingWithServer: false,
        teamIsNew: false,
        error: null,
        message: action.payload.message,
      }
    case SAVE_TEAM_ERROR:
      return {
        ...state,
        syncingWithServer: false,
        error: action.payload,
        message: null,
      }
    case END_EDITING_TEAM:
      return DEFAULT_STATE;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/editingTeamReducer.js